import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng';
import { RequestChannelType } from '../../../enums/request-channel-type';
import { Message } from '../../../classes/Message';
import { GoogleAnalyticsService, JobsService, SettingsService } from '../../../services';
import { SupplierInboxJobsService } from '../../../services';
import { JobAcceptResult } from '../../../enums/job-accept-result';
import { DialogStep } from '../../../components/task-supplier-schedule/supplier-schedule-dialog.component';
import { TaskSupplierScheduleSource } from '../../../components/task-supplier-schedule/task-supplier-schedule-store';
import {
  ConfirmAllocationRequest,
  UpdateTaskScheduleDTO,
} from '../../../components/task-supplier-schedule/task-supplier-schedule';
import { SupplierJobInteractionService } from '../../../services';
import { SupplierJobChannel } from '../../../enums/supplier-job-channel';

export interface IAcceptJob {
  id: number;
  supplierPrice: number;
}

@Component({
  selector: 'accept-job-dialog',
  templateUrl: './accept-job-dialog.component.html',
  styleUrls: ['./accept-job-dialog.component.scss'],
})
export class AcceptJobDialogComponent implements OnInit {
  @Input() jobId: number;

  @Input() supplierPrice: number;

  @Input() visible: boolean = false;

  @Input() referrPage: string;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() jobAccepted: EventEmitter<number> = new EventEmitter<number>();

  public taskScheduleSource: TaskSupplierScheduleSource = TaskSupplierScheduleSource.GrabJob;

  private googleAnalyticsEventCategory: string = 'supplier_jobs_inbox';
  @Input() googleAnalyticsEventLabel: string;

  @Input() supplierJobChannel: SupplierJobChannel;

  constructor(
    private messageService: MessageService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private supplierInboxJobsService: SupplierInboxJobsService,
    public settingsService: SettingsService,
    private supplierJobInteractionService: SupplierJobInteractionService,
  ) {}

  ngOnInit() {}

  close() {
    this.visibleChange.emit(false);
  }

  async acceptJob(request: ConfirmAllocationRequest) {
    this.supplierJobInteractionService.logSingleJobInteraction('BuyJobAttempt', this.jobId);

    this.googleAnalyticsService.eventEmitter(
      'accept_job',
      this.googleAnalyticsEventCategory,
      'accept_job',
      this.googleAnalyticsEventLabel,
    );

    let res = await this.supplierInboxJobsService.acceptJob({
      jobId: this.jobId,
      taskSupplierSchedules: request.updateTaskScheduleDTOs,
      requestChannel: RequestChannelType.WebPortal,
      supplierJobChannel: this.supplierJobChannel,
    });

    this.close();

    if (res == JobAcceptResult.Success) {
      this.messageService.add(Message.Success('Job accepted.'));
      this.jobAccepted.emit();
      this.supplierJobInteractionService.logSingleJobInteraction('BuyJobSuccess', this.jobId);
    } else if (res == JobAcceptResult.PreviouslyAccepted) {
      this.messageService.add(Message.Error('This job has been already accepted'));
    } else if (res == JobAcceptResult.TaskTypeRequirementNotMet) {
      this.messageService.add(
        Message.Error("One or more orders in this Job no longer matches Supplier's capabilities."),
      );
    } else if (res == JobAcceptResult.JobCancelled) {
      this.messageService.add(Message.Error('This job has been cancelled.'));
    } else if (res == JobAcceptResult.JobGrabDisabled) {
      this.messageService.add(Message.Error('This job is no longer available for grabbing.'));
    } else if (res == JobAcceptResult.InactiveOrganisation) {
      this.messageService.add(Message.Error('This organisation is currently inactive.'));
    } else if (res == JobAcceptResult.InactiveUser) {
      this.messageService.add(Message.Error('This user is currently inactive.'));
    } else if (res == JobAcceptResult.SuspendedOrganisation) {
      this.messageService.add(Message.Error('This organisation is currently suspended.'));
    }

    if (
      request.updateTaskScheduleDTOs.length == 1 &&
      request.updateTaskScheduleDTOs[0].updateDefaultTravelMode
    ) {
      void this.supplierInboxJobsService.updateDefaultTaskCollectionTravelMode(
        request.updateTaskScheduleDTOs[0].taskCollectionTravelMode,
      );
    }

    this.jobAccepted.emit(this.jobId);
  }
}
